import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import founderImg from "../assests/Images/Personal/founderPic.png";
import aboutusImage from "../assests/Images/kalkaCapitalImage.jpg";
import {
  faBuilding,
  faChartColumn,
  faFirstAid,
  faMoneyBill,
  faPlus,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import { faTeamspeak } from "@fortawesome/free-brands-svg-icons";
const cardArray = [
  {
    title: "Loans",
    desc: "We can help you unlocking financial freedom.",
    icon: faMoneyBill,
  },
  {
    title: "Insurance",
    desc: "Did you find best insurance for yourself yet?",
    icon: faFirstAid,
  },
  {
    title: "Construction",
    desc: "Building your imagination is our destination.",
    icon: faBuilding,
  },
  {
    title: "Investment",
    desc: "Your money can have better place than bank.",
    icon: faChartColumn,
  },
  {
    title: "Consulting",
    desc: "Are you worried or have doubts? Regarding the starting in business, Talk to us.",
    icon: faTeamspeak,
  },
];

const faqs = [
  {
    question: "What services does Kalka Capital offer?",
    answer:
      "Kalka Capital specializes in providing financial solutions, including loans, investment advice, and business financing tailored to your needs.",
  },
  {
    question: "What types of loans can I apply for with Kalka Capital?",
    answer:
      "We offer a variety of loans such as personal loans, business loans, home loans, vehicle loans, and more.",
  },
  {
    question: "How can I apply for a loan?",
    answer:
      "You can apply for a loan through our website, by visiting our office, or by contacting our customer support team for assistance.",
  },
  {
    question: "What documents are required for a loan application?",
    answer:
      "Documents required may vary based on the type of loan, but generally include identity proof, income proof, address proof, and bank statements.",
  },
  {
    question: "What is the process for loan approval?",
    answer:
      "After submitting your application and required documents, our team will review your eligibility, and once approved, the loan amount will be disbursed to your account.",
  },
  {
    question: "How long does the loan approval process take?",
    answer:
      "Loan approval typically takes 3-7 business days, depending on the type of loan and completeness of your application.",
  },
  {
    question: "Does Kalka Capital offer investment advisory services?",
    answer:
      "Yes, we provide tailored investment advice to help you grow your wealth and achieve financial security.",
  },
  {
    question: "Are there any prepayment charges for loans?",
    answer:
      "Prepayment charges depend on the loan terms. Please refer to your loan agreement or contact us for more details.",
  },
  {
    question: "Can I check my loan eligibility online?",
    answer:
      "Yes, you can use the loan eligibility calculator on our website to get an estimate.",
  },
  {
    question: "How do I contact Kalka Capital for support?",
    answer:
      "You can reach us through email, phone, or by visiting our office. All contact details are available on our website.",
  },
];

const Card = ({ icon, title, desc, index }) => (
  <div
    key={index}
    className="bg-white shadow-lg rounded-lg p-6 w-full lg:w-96 transform hover:scale-105 transition-all mb-4"
  >
    <div className="flex items-center space-x-4">
      <FontAwesomeIcon
        icon={icon}
        className="text-red-600 w-12 h-12 hover:text-red-800"
      />
    </div>
    <h3 className="text-xl font-bold text-gray-800 mt-4">{title}</h3>
    <p className="text-gray-600 mt-2">{desc}</p>
  </div>
);

const AboutUs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="p-6 md:p-12 bg-gray-50 text-gray-800 min-h-screen">
      {/* Header Section */}
      <header className="py-12 px-6">
        <div className="container mx-auto ">
          <h1 className="text-3xl md:text-5xl font-bold text-center md:text-right">
            About Us
          </h1>
          <p className="text-lg mt-4 font-light"></p>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto md:px-6 md:py-12">
        {/* Who We Are Section */}
        <section>
          <h2 className="md:text-3xl font-bold text-gray-900 mb-4">
            Who We Are
          </h2>
          <div className="md:flex gap-2">
            <div className="text-justify">
              <p className="text-lg leading-relaxed md:w-4/5 text-gray-700">
                At
                <span className="px-2 font-semibold text-red-500">
                  Kalka Capital,
                </span>
                we are a team of passionate peoples dedicated to provide the
                best services for you, We do worry about your every concern, Our
                team give you assistance any time as per your requirements and
                we try to complete the procedure without letting you feel hassle
                or irritation.
                <br />
                Join us today and start getting the benefits, Different peoples
                different options, Everything for Everybody.
              </p>
            </div>
            <div className="w-full md:w-3/4">
              <img src={aboutusImage} alt="" />
            </div>
          </div>
        </section>
        <section>
          <h2 className="text-[16px] text-center md:text-3xl font-bold text-red-600 mb-4 md:text-left pt-10">
            Shri Raju Choudhary the founder & CEO of Kalka Capital
            Private Limited
          </h2>
          <div className="flex flex-col md:flex-row gap-2">
            <div>
              <img
                src={founderImg}
                alt="Shree Raju Choudhary [ Founder & CEO ]"
              />
            </div>
            <div className="text-justify">
              <p className="text-lg leading-relaxed  md:w-4/5 ml-auto text-gray-700">
                <b>Shri Raju Choudhary</b> is the Founder and CEO of Kalka
                Capital Private Limited. With a strong foundation in banking,
                Shri Choudhary embarked on his professional journey in 2009 as a
                Deputy Manager at HDFC Bank Ltd in South Delhi. Over the next
                seven years, he honed his skills, gaining invaluable experience
                in the financial sector.
              </p>
              <p className="text-lg leading-relaxed md:w-4/5 ml-auto text-gray-700">
                In 2015, driven by a passion for entrepreneurship and a vision
                to provide innovative financial solutions, he founded Kalka
                Capital. Under his leadership, the firm has grown steadily,
                earning a reputation for its client-centric approach and
                expertise in the financial services industry.
              </p>
              <p className="text-lg leading-relaxed md:w-4/5 ml-auto text-gray-700">
                A significant milestone came in March 2023, when Kalka Capital
                received recognition as a Startup India-certified company,
                marking a new chapter in the firm’s growth and success.
              </p>
              <p className="text-lg leading-relaxed md:w-4/5 ml-auto text-gray-700">
                Through dedication, innovation, and strategic leadership, Shri
                Raju Choudhary continues to guide Kalka Capital towards
                achieving its mission of providing exception
              </p>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="rounded-lg shadow-md mt-10 md:flex md:gap-8">
          <div className="bg-gray-100 md:w-1/2 p-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center">
              Our Mission
            </h2>
            <p className="text-sm md:text-lg leading-relaxed text-gray-700 text-center">
              Our mission is to empower individuals and businesses by providing
              accessible, reliable, and innovative financial solutions that
              faster growth and financial well-being.
            </p>
          </div>
          <div className="bg-white md:w-1/2 p-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center">
              Our Vision
            </h2>
            <p className="text-sm md:text-lg leading-relaxed text-gray-700 text-center">
              Our Vision is to be the most admired financial solutions
              provider, offering a broad range of products and services that
              enhance the financial well-being of our customers.
            </p>
          </div>
        </section>

        {/* What We Do Section */}
        <section className="py-4">
          <h2 className="py-10 text-3xl font-bold text-gray-900 mb-6 text-center">
            What We Do
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {cardArray.map((cardData) => (
              <Card
                title={cardData.title}
                desc={cardData.desc}
                icon={cardData.icon}
              />
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-xl md:text-4xl font-bold text-center text-red-600 mb-10">
              FAQs for Kalka Capital
            </h2>
            <div className="space-y-2 md:space-y-6">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-lg shadow-lg border transition-transform transform hover:scale-105"
                >
                  <div
                    className="flex justify-between items-center cursor-pointer"
                    onClick={() => toggleFAQ(index)}
                  >
                    <h3 className="text-sm md:text-xl font-semibold text-gray-800">
                      {faq.question}
                    </h3>
                    <FontAwesomeIcon
                      icon={activeIndex === index ? faMinus : faPlus}
                      className="text-red-500 text-lg"
                    />
                  </div>
                  <div
                    className={`overflow-hidden transition-max-height duration-500 ease-in-out ${
                      activeIndex === index ? "max-h-screen mt-4" : "max-h-0"
                    }`}
                  >
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="bg-red-500 text-white rounded-lg shadow-md p-8">
          <h2 className="text-3xl font-bold mb-4 text-center">
            Why Choose Us?
          </h2>
          <p className="text-lg leading-relaxed text-center">
            We combine creativity, technology, and strategy to deliver impactful
            solutions. With a client-first approach, we ensure that your vision
            is realized to perfection.
          </p>
        </section>
      </main>
    </div>
  );
};

export default AboutUs;
